import React from "react";

export function highlightKeyword(text: string, keyword?: string | null): React.ReactNode {
  if (!keyword || !text) return text;
  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  return (
    <span
      style={{ pointerEvents: 'none' }}
      dangerouslySetInnerHTML={{
        __html: text.replace(
          new RegExp(escapedKeyword, "gi"),
          (match) => `<strong class='klayo-selector_highlight'>${match}</strong>`
        )
      }}
    />
  );
}
